const invoiceTypeEnum = [
    {
        name: "PARTIAL_INVOICE",
        value: 1
    },
    {
        name: "FINAL_INVOICE",
        value: 2
    },
    {
        name: "CORRECTIVE_INVOICE",
        value: 3
    }
];

export default invoiceTypeEnum;